import { useState } from 'react';
import { accessibleOnClick } from 'govbr.frontend.policy/helpers';
import AnimateHeight from 'react-animate-height';
import { defineMessages, useIntl } from 'react-intl';

import AreaInfoBase from '../../../AreaInfo/AreaInfo';

const messages = defineMessages({
  areaInformation: {
    id: 'area.info.title',
    defaultMessage: 'Area Information',
  },
});

// Wrapper específico da listagem: adiciona título colapsável / espaçamentos.
const AreaInfo = ({ areaData, showTitle }) => {
  const [active, setActive] = useState(false);
  const intl = useIntl();

  // Se não há conteúdo relevante, AreaInfoBase retorna null
  const baseContent = AreaInfoBase({ areaData });
  if (!baseContent) return null;

  return showTitle ? (
    <div className="br-card">
      <div
        className="card-header cursor-pointer py-2"
        {...accessibleOnClick(() => setActive(!active))}
      >
        <div className="text-weight-medium text-interactive">
          {intl.formatMessage(messages.areaInformation)}
          <span
            className={`text-up-01 fas ${active ? 'fa-caret-up' : 'fa-caret-down'} mr-1`}
            aria-hidden="true"
            style={{ minWidth: '16px' }}
          />
        </div>
      </div>
      <AnimateHeight
        animateOpacity
        duration={600}
        height={showTitle && active ? 'auto' : 0}
      >
        <div className="card-content">{baseContent}</div>
      </AnimateHeight>
    </div>
  ) : (
    <div className="mt-1 mb-5 ml-4">{baseContent}</div>
  );
};

export default AreaInfo;
